import AddressDisplay from 'common/components/address/AddressDisplay';
import AddressOnlyDisplay from 'common/components/address/AddressOnlyDisplay';
import CreditCardDisplay from 'profile/creditCard/CreditCardDisplay';

import CustomerDisplay from './CustomerDisplay';

const ContentSummary = (props) => {
  const { clubSignup, customer, currentStep, onEdit, settings } = props;
  if (currentStep === 'customer') {
    return null;
  }
  return (
    <div className="c7-checkout__content__summary">
      {renderCustomer(currentStep, clubSignup, customer, onEdit, settings)}
      {renderBilling(currentStep, clubSignup, customer, onEdit, settings)}
      {renderAccount(currentStep, clubSignup, customer, onEdit)}
      {renderPayment(currentStep, clubSignup, onEdit)}
    </div>
  );
};
export default ContentSummary;

const renderCustomer = (step, clubSignup, customer, onEdit, settings) => {
  const handleEdit = (e) => {
    e.preventDefault();
    onEdit('customer');
  };

  const renderGiftMessage = (message) => (
    <div>
      <div>
        <div>Gift message</div>
        <div>{message}</div>
      </div>
      <a onClick={handleEdit}>Edit</a>
    </div>
  );

  const renderShippingInstructions = (shippingInstructions) => (
    <div>
      <div>
        <div>Shipping Instructions</div>
        <div>{shippingInstructions}</div>
      </div>
      <a onClick={handleEdit}>Edit</a>
    </div>
  );

  if (
    step === 'account' ||
    step === 'billing' ||
    step === 'payment' ||
    step === 'complete'
  ) {
    return (
      <>
        <div>
          <div>
            <div>Contact information</div>
            <div>
              <CustomerDisplay clubSignup={clubSignup} customer={customer} />
            </div>
          </div>
          <a onClick={handleEdit}>Edit</a>
        </div>
        {renderAddress(clubSignup, settings, handleEdit)}
        {clubSignup.giftMessage && renderGiftMessage(clubSignup.giftMessage)}
        {clubSignup.shippingInstructions &&
          renderShippingInstructions(clubSignup.shippingInstructions)}
      </>
    );
  }
  return null;
};

const renderBilling = (step, clubSignup, customer, onEdit) => {
  const handleEdit = (e) => {
    e.preventDefault();
    onEdit('billing');
  };

  if (step === 'account' || step === 'payment' || step === 'complete') {
    return (
      <>
        <div>
          <div>
            <div>Billing information</div>
            <div>
              <AddressDisplay address={clubSignup.billTo} />
            </div>
          </div>
          <a onClick={handleEdit}>Edit</a>
        </div>
      </>
    );
  }
  return null;
};

const renderAddress = (clubSignup, settings, handleEdit) => {
  if (clubSignup.orderDeliveryMethod === 'Pickup') {
    return (
      <div>
        <div>
          <div>Pickup address</div>
          <div>
            <AddressOnlyDisplay address={clubSignup.pickupAt} />
          </div>
        </div>
        <a onClick={handleEdit}>Edit</a>
      </div>
    );
  }
  return (
    <div>
      <div>
        <div>Shipping address</div>
        <div>
          <AddressDisplay address={clubSignup.shipTo} />
        </div>
      </div>
      <a onClick={handleEdit}>Edit</a>
    </div>
  );
};

const renderAccount = (step, clubSignup, customer, onEdit) => {
  const handleEdit = (e) => {
    e.preventDefault();
    onEdit('account');
  };
  if (step === 'complete' && !customer) {
    return (
      <div>
        <div>
          <div>Account</div>
          <div>Password: ********</div>
        </div>
        <a onClick={handleEdit}>Edit</a>
      </div>
    );
  }
  return null;
};

const renderPayment = (step, clubSignup, onEdit) => {
  const handleEdit = (e) => {
    e.preventDefault();
    onEdit('payment');
  };
  if (step === 'complete') {
    return (
      <div>
        <div>
          <div>Payment info</div>
          <div>
            <CreditCardDisplay creditCard={clubSignup.creditCard} />
          </div>
        </div>
        <a onClick={handleEdit}>Edit</a>
      </div>
    );
  }
  return null;
};
